export enum TabletStatus {
  UNKNOWNTABLETSTATUS = 'UNKNOWN_TABLET_STATUS',
  UNINITIALIZED = 'UNINITIALIZED',
  RUNNING = 'RUNNING',
  SUSPENDED = 'SUSPENDED'
}
